import { useOfferCardContext } from '../context/offerCardContext';

export const usePublisher = () => {
  const { publisher } = useOfferCardContext();

  return publisher;
};
